// extracted by mini-css-extract-plugin
export default {"title":"styles_title__3DmJg","title_white":"styles_title_white__V4DTj","title_desktop":"styles_title_desktop__DEn1R","title_mobile":"styles_title_mobile__z8mYG"};